// removed by extract-text-webpack-plugin
module.exports = {"social":"social__3Fg9a","text":"text__3ScZs","links":"links__x1NnZ"};


//////////////////
// WEBPACK FOOTER
// ./components/social-block/style.css
// module id = KoTl
// module chunks = 4